import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCategories } from "../repositories/storeRep";

const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const getCategoriesData = createAsyncThunk(
  "categories",
  async (thunkAPI) => {
    const response = await getCategories();
    return response;
  }
);
export const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  extraReducers: {
    [getCategoriesData.pending]: (state) => {
      state.loading = true;
    },
    [getCategoriesData.fulfilled]: (state, action) => {
      state.loading = false;
       const data = [["1","books","Find books, toys & tech, including ebooks, movies, music & textbooks.",""],
       ["2","movies","Find books, toys & tech, including ebooks, movies, music & textbooks.",""],
       ["3","software","Find books, toys & tech, including ebooks, movies, music & textbooks.",""]];
    //   action.payload.data.map((element) => {
    //     data.push(Object.values(element));
    //   });
      state.data = data;
    },
    [getCategoriesData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default categoriesSlice.reducer;
